<div>
  <ng-container *ngIf="{ emailTypes: emailTypes$ | async, phoneTypes: phoneTypes$ | async } as resultTypes">
    <ng-container>
      <div class="d-flex flex-column">
        <div class="w-100 d-flex align-items-center justify-content-between">
          <span class="fw-medium body-md">Email</span>
          <button mat-button color="primary" (click)="addEmail()">
            <mat-icon class="md-icon-22">add_circle</mat-icon>
            <span>Add Email</span>
          </button>
        </div>
        <mat-divider></mat-divider>
        <ng-container *ngFor="let item of emails; let i = index">
          <ng-container *ngIf="item.isValid && item.isValid > 0">
            <div class="w-100" style="margin-top: 16px; margin-bottom: 16px; display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px;">
              <div>
                <input type="text" class="form-control" style="height: 44px; padding: 12px 16px; font-size: 16px;" #email [(ngModel)]="item.email" name="email" (blur)="emailValueChange(i, email.value)" [ngModelOptions]="{ standalone: true }"/>
                <mat-error *ngIf="item.valid === 0"> Email address is not valid </mat-error>
              </div>

              <div>
                <select class="form-select" style="height: 44px; padding: 9px 16px; font-size: 16px; border-radius: 4px;" [(ngModel)]="item.emailTypeId" name="emailType" [ngModelOptions]="{ standalone: true }" [compareWith]="compareById">                    
                  <option *ngFor="let type of resultTypes.emailTypes" [ngValue]="type.emailTypeId">
                    {{ type.emailTypeDesc | titlecase}}
                  </option>
                </select>
              </div>

              <div class="d-flex align-items-center">
                <div 
                  *ngIf="item.isPrimary === 1" 
                  (click)="item.isPrimary = item.isPrimary === 1 ? 0 : 1; handlePrimaryEmail(item, i)"
                  class="d-flex align-items-center justify-content-center mat-background-gray-300 cursor-pointer"
                  style="border-radius: 4px; width: 120px; height: 26px;"
                  >Primary
                </div>
                <div 
                  *ngIf="item.isPrimary !== 1" 
                  (click)="item.isPrimary = item.isPrimary === 1 ? 0 : 1; handlePrimaryEmail(item, i)"
                  class="d-flex align-items-center justify-content-center fw-medium mat-color-primary-500 body-lg cursor-pointer"
                  style="width: 120px; height: 26px; text-decoration: underline;"
                  >Set as primary
                </div>
  
                <button mat-button class="p-0" style="margin-left: 16px; width: 44px; min-width: 44px; height: 44px; border: 1px solid #BDBDBD; border-radius: 4px;" (click)="deleteEmail(i)">
                  <mat-icon class="m-0 md-icon-22" color="primary">remove_circle</mat-icon>
                </button>
              </div>

            </div>
          </ng-container>
        </ng-container>
      </div>

      <div class="d-flex flex-column mt-4">
        <div class="w-100 d-flex align-items-center justify-content-between">
          <span class="fw-medium body-md">Phone number</span>
          <button mat-button color="primary" (click)="addPhoneNumber()">
            Add phone number
            <mat-icon class="md-icon-22">add_circle</mat-icon>
          </button>
        </div>
        <mat-divider></mat-divider>
        <ng-container *ngFor="let item of phones; let i = index">
          <ng-container *ngIf="item.isValid && item.isValid > 0">
            <div class="w-100" style="margin-top: 16px; margin-bottom: 16px; display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px;">
              <div>
                <input 
                  #phone 
                  placeholder="(___)___-___" 
                  [(ngModel)]="item.phoneNumber"
                  [name]="item.phoneNumber"
                  type="phone"
                  (blur)="phoneNumberValueChange(i, phone.value)"
                  class="form-control"
                  appPhoneMaskclass="form-control" 
                  appPhoneMask
                  style="height: 44px; padding: 12px 16px; font-size: 16px;" 
                  [ngModelOptions]="{ standalone: true }"/>
                <mat-error *ngIf="item.valid === 0"> Phone number is not valid </mat-error>
              </div>

              <div>
                <select class="form-select" style="height: 44px; padding: 9px 16px; font-size: 16px; border-radius: 4px;" [(ngModel)]="item.contactType" name="emailType" [ngModelOptions]="{ standalone: true }" [compareWith]="compareById">                    
 
                  <option *ngFor="let type of resultTypes.phoneTypes" [ngValue]="type.phoneTypeId" class="text-capitalize">
                    {{ type.phoneTypeDesc | titlecase}}
 
                  </option>
                </select>
              </div>

              <div class="d-flex align-items-center">
                <div 
                  *ngIf="item.isPrimary === 1" 
                  (click)="item.isPrimary = item.isPrimary === 1 ? 0 : 1; handlePrimaryPhone(item, i)"
                  class="d-flex align-items-center justify-content-center mat-background-gray-300 cursor-pointer"
                  style="border-radius: 4px; width: 120px; height: 26px;"
                  >Primary
                </div>
                <div 
                  *ngIf="item.isPrimary !== 1" 
                  (click)="item.isPrimary = item.isPrimary === 1 ? 0 : 1; handlePrimaryPhone(item, i)"
                  class="d-flex align-items-center justify-content-center fw-medium mat-color-primary-500 body-lg cursor-pointer"
                  style="width: 120px; height: 26px; text-decoration: underline;"
                  >Set as primary
                </div>
  
                <button mat-button class="p-0" style="margin-left: 16px; width: 44px; min-width: 44px; height: 44px; border: 1px solid #BDBDBD; border-radius: 4px;" (click)="deletePhoneNumber(i)">
                  <mat-icon class="m-0 md-icon-22" color="primary">remove_circle</mat-icon>
                </button>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>

  <div class="d-flex justify-content-end" style="margin-top: 16px;">
    <button mat-flat-button color="primary" class="body-md" style="height: 44px;" (click)="save()">
    Save
    </button>
  </div>
</div>
